import { fileDocGroupAndTypes } from "../../constants/fileDocGroupAndTypes";

export const useFileDocGroupAndTypesHook = () => {
  // const fileDocGroupAndTypes = useSelector(
  //   (state) => state.fetchedSelections?.fileDocGroupAndTypes || {}
  // );

  const fileDocGroups = Object.keys(fileDocGroupAndTypes);
  const getFileDocGroups = (docGroupTypesObject) => {
    if (docGroupTypesObject) {
      return Object.keys(docGroupTypesObject);
    }
    return fileDocGroups;
  };

  const getDocTypesByGroup = (group, docGroupTypesObject) => {
    if (docGroupTypesObject) {
      return docGroupTypesObject[group];
    }
    return fileDocGroupAndTypes[group];
  };

  const searchDocumentsAdvanced = (searchTerm) => {
    if (!searchTerm || typeof searchTerm !== "string") {
      return fileDocGroupAndTypes;
    }

    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    if (normalizedSearchTerm === "") {
      return fileDocGroupAndTypes;
    }

    // Split search term into words for better matching
    const searchWords = normalizedSearchTerm.split(/\s+/);

    const results = {};

    Object.entries(fileDocGroupAndTypes).forEach(([docGroup, docTypes]) => {
      const normalizedDocGroup = docGroup.toLowerCase();

      // Check if docGroup matches any search word
      const docGroupMatches = searchWords.some((word) =>
        normalizedDocGroup.includes(word),
      );

      // Find matching doc types
      const matchingDocTypes = docTypes.filter((docType) => {
        const normalizedDocType = docType.toLowerCase();
        return searchWords.some((word) => normalizedDocType.includes(word));
      });

      if (docGroupMatches || matchingDocTypes.length > 0) {
        results[docGroup] = docGroupMatches ? docTypes : matchingDocTypes;
      }
    });

    return results;
  };

  const getDocumentTypeOptions = (passedFileDocGroupAndTypes) => {
    const fileDocGroupAndTypesObject =
      passedFileDocGroupAndTypes || fileDocGroupAndTypes;
    const options = [];

    Object.entries(fileDocGroupAndTypesObject).forEach(([group, docTypes]) => {
      docTypes.forEach((docType) => {
        options.push({
          label: `${group} > ${docType}`,
          value: `${group} > ${docType}`,
          docGroup: group,
          docType: docType,
        });
      });
    });

    return options;
  };

  return {
    fileDocGroupAndTypes,
    fileDocGroups,
    getDocTypesByGroup,
    getDocumentTypeOptions,
    searchDocumentsAdvanced,
    getFileDocGroups,
  };
};

/**
  const fileDocGroupAndTypes = useSelector(
    (state) => state.fetchedSelections?.fileDocGroupAndTypes
  );

  const {
    fileDocGroupAndTypes,
    fileDocGroups,
    getDocTypesByGroup,
    getDocumentTypeOptions,
    searchDocumentsAdvanced,
    getFileDocGroups,
  } = useFileDocGroupAndTypesHook();

 */
